import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";

export type LandingPageSliceStateKeys = "";
export interface ILandingPageSliceState extends IRouteReducerSliceStateInit {
  state?: {
    heroTitle?: string;
  };
}
const initialState: ILandingPageSliceState = {};

const landingPageSlice = createSlice({
  name: "landing_page_slice",
  initialState: initialState,
  reducers: {
    /* Cleans Up state with multiple state keys */
    cleanupRoot: (state, action: PayloadAction<{ keys: LandingPageSliceStateKeys[] }>) => {
      for (let i = 0; i < action.payload.keys.length; i++) {
        state[action.payload.keys[i]] = null;
      }
    },
  },
});

export const { cleanupRoot } = landingPageSlice.actions;

export default landingPageSlice.reducer;
